import { createSlice } from '@reduxjs/toolkit';
import { generateReduxKeys } from '../../utils';

const initialState = generateReduxKeys({
    groups: [],
    members: [],
    activeGroup: null
});

const groupSlice = createSlice({
    name: 'groups',
    initialState,
    reducers: {
        setGroups: (state, action) => {
            localStorage.setItem('groups', JSON.stringify(action.payload));
            state.groups = action.payload;
        },
        setMembers: (state, action) => {
            localStorage.setItem('members', JSON.stringify(action.payload));
            state.members = action.payload;
        },
        setActiveGroup: (state, action) => {
            state.activeGroup = action.payload;
        },
    },
});

export const { setGroups, setMembers, setActiveGroup } = groupSlice.actions;

export default groupSlice.reducer;
